export const availableSitesKeys = {
  all: ['available-sites'] as const,
};
